import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      component: () => import('../views/index/index.vue'),

    },

  ],
  scrollBehavior: () => ({
    y: 0
  }),
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js